import { useState } from 'react';

// Shows a freshly-issued plant agent token exactly once. The server only stores
// the token's hash, so this modal is the operator's single chance to copy it.
export default function PlantTokenReveal({ plantId, token, note, onClose }) {
  const [copied, setCopied] = useState(false);
  if (!token) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(token);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch { /* clipboard blocked — the operator can still select the text */ }
  };

  const overlay = {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000,
  };
  const box = {
    width: 'min(560px, 92vw)', background: '#141a24', color: '#e4e6eb',
    border: '1px solid #2a3441', borderRadius: 12, padding: 22,
    boxShadow: '0 12px 40px rgba(0,0,0,.5)',
  };

  return (
    <div style={overlay} data-testid="token-reveal" onClick={onClose}>
      <div style={box} onClick={(e) => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 6px', color: '#ffd76a' }}>🔑 Plant token for “{plantId}”</h3>
        <p style={{ margin: '0 0 12px', color: '#ff9f6a', fontSize: 13 }}>
          {note || 'Copy this token now — it is shown only once.'}
        </p>
        <div style={{ display: 'flex', gap: 8 }}>
          <code
            data-testid="token-value"
            style={{ flex: 1, fontFamily: 'monospace', fontSize: 13, background: '#0d0d13',
                     border: '1px solid #282833', borderRadius: 8, padding: '10px 12px', wordBreak: 'break-all' }}>
            {token}
          </code>
          <button data-testid="copy-btn" onClick={copy}
            style={{ padding: '0 14px', borderRadius: 8, border: '1px solid #2a3441',
                     background: '#1f6feb', color: '#fff', cursor: 'pointer' }}>
            {copied ? 'Copied' : 'Copy'}
          </button>
        </div>
        <p style={{ margin: '12px 0 0', color: '#7a8594', fontSize: 12 }}>
          Paste it into the plant agent’s <b>Plant Token</b> field. If lost, use “Rotate token”.
        </p>
        <div style={{ marginTop: 16, textAlign: 'right' }}>
          <button data-testid="close-btn" onClick={onClose}
            style={{ padding: '8px 16px', borderRadius: 8, border: 'none',
                     background: '#2a3441', color: '#e4e6eb', cursor: 'pointer' }}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
